export const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export const CLABE_PATTERN = /^\d{4}\s?\d{4}\s?\d{4}\s?\d{4}\s?\d{2}$/;
